import i18next from "i18next";
// English JSON
import SideBarEng from "./en-US/Dashboard/sidebar.json";
import DashboardEng from "./en-US/Dashboard/dashboard.json";
import ApplicationMenuEng from "./en-US/Dashboard/applicationMenu.json";
import ShipmentEng from "./en-US/Shipment/shipment.json";
import ShipmentDetailEng from "./en-US/Shipment/details.json";
import CreateShipmentEng from "./en-US/Shipment/create.json";
import CreateBREng from "./en-US/BookingRequest/create_br.json";
import OrderListEng from "./en-US/Shipment/orders/orderList.json";
import OrderDetailEng from "./en-US/Shipment/orders/details.json";
import CreateOrderEng from "./en-US/Shipment/orders/create.json";
import TitleBarEng from "./en-US/titleBar.json";
import VendorListEng from "./en-US/Master/Vendor/vendor.json";
import CreateVendorEng from "./en-US/Master/Vendor/create.json";
import VehicleTypeEng from "./en-US/Master/Vehicle Type/vehicle_type.json";
import UserListEng from "./en-US/Master/User/user.json";
import CreateUserEng from "./en-US/Master/User/create.json";
import DriverEng from "./en-US/Master/Driver/driver.json";
import ConsignorListEng from "./en-US/Master/Consignor/consignor.json";
import CreateConsignorEng from "./en-US/Master/Consignor/create.json";
import ConsigneeListEng from "./en-US/Master/Consignee/consignee.json";
import CreateConsigneeEng from "./en-US/Master/Consignee/create.json";
import CreateBillingPartyEng from "./en-US/Master/billingParty/create.json";
import SKUEng from "./en-US/Master/SKU/sku.json";
import RouteEng from "./en-US/Master/Route/route.json";
import CityEng from "./en-US/Master/City/city.json";
import AgGridEng from "./en-US/agGrid.json";
import VendorGroupEng from "./en-US/Master/Vendor Group/vendor_group.json";
import vehicleDetailsEng from "./en-US/Shipment/vehicle/vehicleDetails.json";
import AllotEng from "./en-US/Shipment/allocation/allot.json";
import BroadcastEng from "./en-US/Shipment/allocation/broadcast.json";
import UndoBroadcastEng from "./en-US/undoModalBroadcast/undoBroadcast.json";
import CancelShipmentEng from "./en-US/Shipment/cancelshipment.json";
import BidHistoryEng from "./en-US/Shipment/allocation/bidHistory.json";
import VendorReplyEng from "./en-US/Shipment/allocation/vendorReplies.json";
import RejectReasonEng from "./en-US/Shipment/orders/reject.json";
import UserRole from "./en-US/Master/user Role/user_role.json";
import DocumentEng from "./en-US/Shipment/document.json";
import VendorShareEng from "./en-US/Master/Vendor Share/vendor_share.json";
import UserTableEng from './en-US/usertable/userTable.json';
import rateChartEng from './en-US/rateChart/rateChart.json';
import branchEng from './en-US/branch/branch.json';
import vehicleEng from './en-US/vehicle/vehicle.json';
import OrdersEng from './en-US/allOrders/allOrders.json';
import rebidEng from './en-US/Shipment/rebidmodal.json';
import fileimportmasterEng from './en-US/Master/importModal.json';
import alertEng from './en-US/Master/alerts.json';
import allBranchEng from './en-US/Master/branch/branch.json';
import vehicleavaiEng from './en-US/vehicleAvailability/vehicleavailability.json';
import deliveryListEng from './en-US/delivery/deliverylist.json';
import clubBookingsEng from './en-US/clubBookings/clubBookings.json'
// Portuguese JSON
import deliveryListPtr from './pt-BR/delivery/deliverylist.json';
import vehicleavaiPtr from './pt-BR/vehicleAvailability/vehicleavailability.json';
import alertPrt from './pt-BR/Master/alerts.json';
import allBranchPtr from './pt-BR/Master/branch/branch.json';
import SidebarPtr from "./pt-BR/Dashboard/sidebar.json";
import rebidPtr from './pt-BR/Shipment/rebidmodal.json';
import fileimportmasterPtr from './pt-BR/Master/importModal.json';
import DashboardPtr from "./pt-BR/Dashboard/dashboard.json";
import ApplicationMenuPtr from "./pt-BR/Dashboard/applicationMenu.json";
import ShipmentPtr from "./pt-BR/Shipment/shipment.json";
import ShipmentDetailPtr from "./pt-BR/Shipment/details.json";
import CreateShipmentPtr from "./pt-BR/Shipment/create.json";
import CreateBRPtr from "./pt-BR/BookingRequest/create_br.json";
import OrderListPtr from "./pt-BR/Shipment/orders/orderList.json";
import OrderDetailPtr from "./pt-BR/Shipment/orders/details.json";
import CreateOrderPtr from "./pt-BR/Shipment/orders/create.json";
import TitleBarPtr from "./pt-BR/titleBar.json";
import VendorListPtr from "./pt-BR/Master/Vendor/vendor.json";
import CreateVendorPtr from "./pt-BR/Master/Vendor/create.json";
import VehicleTypePtr from "./pt-BR/Master/Vehicle Type/vehicle_type.json";
import UserListPtr from "./pt-BR/Master/User/user.json";
import CreateUserPtr from "./pt-BR/Master/User/create.json";
import DriverPtr from "./pt-BR/Master/Driver/driver.json";
import ConsignorListPtr from "./pt-BR/Master/Consignor/consignor.json";
import CreateConsignorPtr from "./pt-BR/Master/Consignor/create.json";
import ConsigneeListPtr from "./pt-BR/Master/Consignee/consignee.json";
import CreateBillingPartyPtr from "./pt-BR/Master/billingParty/create.json";
import CreateConsigneePtr from "./pt-BR/Master/Consignee/create.json";
import SKUPtr from "./pt-BR/Master/SKU/sku.json";
import RoutePtr from "./pt-BR/Master/Route/route.json";
import CityPtr from "./pt-BR/Master/City/city.json";
import AgGridPtr from "./pt-BR/agGrid.json";
import VendorGroupPtr from "./pt-BR/Master/Vendor Group/vendor_group.json";
import vehicleDetailsPtr from "./pt-BR/Shipment/vehicle/vehicleDetails.json";
import AllotPtr from "./pt-BR/Shipment/allocation/allot.json";
import BroadcastPtr from "./pt-BR/Shipment/allocation/broadcast.json";
import BidHistoryPtr from "./pt-BR/Shipment/allocation/bidHistory.json";
import UndoBroadcastPtr from "./pt-BR/undoModalBroadcast/undoBroadcast.json";
import CancelShipmentPtr from "./pt-BR/Shipment/cancelshipment.json";
import VendorReplyPtr from "./pt-BR/Shipment/allocation/vendorReplies.json";
import RejectReasonPtr from "./pt-BR/Shipment/orders/reject.json";
import VendorSharePtr from "./pt-BR/Master/Vendor Share/vendor_share.json";
import UserTablePtr from './pt-BR/usertable/userTable.json';
import rateChartPtr from './pt-BR/rateChart/rateChart.json';
import OrdersPtr from './pt-BR/allOrders/allOrders.json';
import DocumentPtr from './pt-BR/Shipment/document.json';
import UserRolePtr from "./pt-BR/Master/user Role/user_role.json";
import branchPtr from './pt-BR/branch/branch.json';
import vehiclePtr from './pt-BR/vehicle/vehicle.json';
import clubBookingsPtr from './pt-BR/clubBookings/clubBookings.json'




i18next.init({
  debug: true,
  lng: "pt",
  fallbackLng: "pt", // use en if detected lng is not available

  keySeparator: ".", // we do not use keys in form messages.welcome

  interpolation: {
    escapeValue: false, // react already safes from xss
  },

  resources: {
    en: {
      vehicleavailability: vehicleavaiEng,
      sidebar: SideBarEng,
      allbranch: allBranchEng,
      dashboard: DashboardEng,
      application_menu: ApplicationMenuEng,
      shipment: ShipmentEng,
      shipment_details: ShipmentDetailEng,
      create_shipment: CreateShipmentEng,
      create_booking_request: CreateBREng,
      order_list: OrderListEng,
      order_details: OrderDetailEng,
      create_order: CreateOrderEng,
      title_bar: TitleBarEng,
      vendor_list: VendorListEng,
      create_vendor: CreateVendorEng,
      vehicle_type: VehicleTypeEng,
      user_list: UserListEng,
      create_user: CreateUserEng,
      driver: DriverEng,
      consignor_list: ConsignorListEng,
      create_consignor: CreateConsignorEng,
      consignee_list: ConsigneeListEng,
      create_consignee: CreateConsigneeEng,
      create_billing_party: CreateBillingPartyEng,
      sku: SKUEng,
      route: RouteEng,
      city: CityEng,
      ag_grid: AgGridEng,
      vendor_group: VendorGroupEng,
      alloted_vehicle_details: vehicleDetailsEng,
      allot: AllotEng,
      broadcast: BroadcastEng,
      undoBroadcast: UndoBroadcastEng,
      cancelShipment: CancelShipmentEng,
      bidhistory: BidHistoryEng,
      vendor_replies: VendorReplyEng,
      reject_reason: RejectReasonEng,
      user_role: UserRole,
      vendor_share: VendorShareEng,
      user_table: UserTableEng,
      rate_chart: rateChartEng,
      branch: branchEng,
      vehicle: vehicleEng,
      orders: OrdersEng,
      document: DocumentEng,
      rebid: rebidEng,
      importfilemaster: fileimportmasterEng,
      alert: alertEng,
      deliverylist: deliveryListEng,
      club_bookings: clubBookingsEng
    },
    pt: {
      deliverylist: deliveryListPtr,
      vehicleavailability: vehicleavaiPtr,
      branch: branchPtr,
      alert: alertPrt,
      allbranch: allBranchPtr,
      importfilemaster: fileimportmasterPtr,
      vehicle: vehiclePtr,
      rebid: rebidPtr,
      sidebar: SidebarPtr,
      dashboard: DashboardPtr,
      application_menu: ApplicationMenuPtr,
      shipment: ShipmentPtr,
      shipment_details: ShipmentDetailPtr,
      create_shipment: CreateShipmentPtr,
      create_booking_request: CreateBRPtr,
      order_list: OrderListPtr,
      order_details: OrderDetailPtr,
      create_order: CreateOrderPtr,
      title_bar: TitleBarPtr,
      vendor_list: VendorListPtr,
      create_vendor: CreateVendorPtr,
      vehicle_type: VehicleTypePtr,
      user_list: UserListPtr,
      create_user: CreateUserPtr,
      driver: DriverPtr,
      consignor_list: ConsignorListPtr,
      create_consignor: CreateConsignorPtr,
      consignee_list: ConsigneeListPtr,
      create_consignee: CreateConsigneePtr,
      create_billing_party: CreateBillingPartyPtr,
      sku: SKUPtr,
      route: RoutePtr,
      city: CityPtr,
      ag_grid: AgGridPtr,
      vendor_group: VendorGroupPtr,
      alloted_vehicle_details: vehicleDetailsPtr,
      allot: AllotPtr,
      broadcast: BroadcastPtr,
      bidhistory: BidHistoryPtr,
      undoBroadcast: UndoBroadcastPtr,
      cancelShipment: CancelShipmentPtr,
      vendor_replies: VendorReplyPtr,
      reject_reason: RejectReasonPtr,
      user_role: UserRolePtr,
      vendor_share: VendorSharePtr,
      user_table: UserTablePtr,
      rate_chart: rateChartPtr,
      orders: OrdersPtr,
      document: DocumentPtr,
      club_bookings: clubBookingsPtr
    },
  },

  // have a common namespace used around the full app
  ns: [
    "sidebar",
    "dashboard",
    "alert",
    "shipment",
    "shipment_details",
    "create_shipment",
    "create_booking_request",
    "order_list",
    "order_details",
    "create_order",
    "rebid",
    "importfilemaster",
    "title_bar",
    "vendor_list",
    "create_vendor",
    "vehicle_type",
    "application_menu",
    "allbranch",
    "user_list",
    "vehicleavailability",
    "deliverylist",
    "create_user",
    "driver",
    "consignor_list",
    "create_consignor",
    "bidhistory",
    "consignee_list",
    "create_consignee",
    "create_billing_party",
    "sku",
    "route",
    "city",
    "ag_grid",
    "vendor_group",
    "alloted_vehicle_details",
    "allot",
    "broadcast",
    "undoBroadcast",
    "cancelShipment",
    "vendor_replies",
    "reject_reason",
    "user_role",
    "vendor_share",
    "user_table",
    "rate_chart",
    "orders",
    "document",
    "club_bookings"
  ],
  // defaultNS: "translations",
});
export default i18next;
